<template>
	<div class="filter-item">
        <span class="filter-item__name" v-on:click="show = !show">
            {{filter.name}}
            <SvgIcon class="filter-item__icon" iconName="ico-chevron-down"/>
        </span>
		<transition name="fade">
			<div v-if="filter.name === 'Specialties' && this.selectedTags.length > 0">
				<ul class="filter-item__list" v-if="show" v-on:click="show = !show">
					<li v-for="item in this.selectedTags" class="filter-item__item" @click="getFilter(item, filter.name)" :key="item">
						{{item}}
					</li>
				</ul>
			</div>
			<div v-else-if="filter.name === 'Price' && this.getPrices.length > 0">
				<ul class="filter-item__list" v-if="show" v-on:click="show = !show">
					<li v-for="item in this.getPrices" class="filter-item__item" @click="getFilter(item, filter.name)" :key="item">
						{{item}}
					</li>
				</ul>
			</div>
			<div v-else-if="filter.name === 'Servings' && this.getServings.length > 0">
				<ul class="filter-item__list" v-if="show" v-on:click="show = !show">
					<li v-for="item in this.getServings" class="filter-item__item" @click="getFilter(item, filter.name)" :key="item">
						{{item}}
					</li>
				</ul>
			</div>

			<div v-else-if="filter.name === 'Type' && this.getTypes.length > 0">
				<ul class="filter-item__list" v-if="show" v-on:click="show = !show">
					<li v-for="item in this.getTypes" class="filter-item__item" @click="getFilter(item, filter.name)" :key="item">
						{{item}}
					</li>
				</ul>
			</div>
			<div v-else>
				<ul class="filter-item__list" v-if="show" v-on:click="show = !show">
					<li v-for="item in filter.list" class="filter-item__item" @click="getFilter(item, filter.name)" :key="item">
						{{item}}
					</li>
				</ul>
			</div>
		</transition>
	</div>
</template>

<script>
	import SvgIcon from '../base/SvgIcon/SvgIcon.vue';

	export default {
		props: {
			filter: {
				type: Object,
				required: true
			}
		},
		created() {
			// eslint-disable-next-line
			const that = this;
			setTimeout(function() {
				that.filterOptions(that.filter);
			}, 1000);
		},
		methods: {
			filterOptions(filter) {
				if (filter.name === 'Specialties') {
					this.selectedTags = this.$store.getters.getTags;
				}
				if (filter.name === 'Price') {
					this.selectedPrice = this.$store.getters.getLargestPrice;
					const prices = [];
					// eslint-disable-next-line no-undef
					// let currentKey = 0;
					filter.list.forEach((element) => {
						this.checkingPrice(element);
						if (this.checkingPrice(element)) {
							prices.push(element);
						}
					});
					// console.log(prices);
					//	prices.push(filter.list[currentKey + 1]);
					//	console.log(prices);
					this.getPrices = prices;
				}
				if (filter.name === 'Servings') {
					this.selectedServing = this.$store.getters.getLargestServing;
					const servings = [];
					//	let currentKey = 0;
					filter.list.forEach((element) => {
						if (this.checkingServing(element)) {
							servings.push(element);
						}
					});
					//servings.push(filter.list[currentKey + 1]);
					this.getServings = servings;
				}
				if (filter.name === 'Type') {
					this.getTypes = this.$store.getters.getTypes;
				}
			},
			getFilter(item, filter) {
				const payload = {
					filter: item
				};
				if (filter === 'Specialties') {
					this.$store.dispatch('setChosenFilterDishType', payload);
				} else if (filter === 'Type') {
					this.$store.dispatch('setChosenFilterEventType', payload);
				} else if (filter === 'Servings') {
					this.$store.dispatch('setChosenFilterPeople', payload);
				} else if (filter === 'Price') {
					this.$store.dispatch('setChosenFilterPrice', payload);
				}

				this.doFiltration();
			},
			checkingPrice(price) {
				price = price.split('-');
				//	const lower = price[0].replace('$', '');
				const higher = price[1].replace('$', '');
				// if (this.$store.getters.getLargestPrice.length > 0) {
				// 	this.$store.getters.getLargestPrice.forEach((element) => {
				// 		console.log('...');
				// 		console.log(parseFloat(price[0]), parseFloat(element), parseFloat(price[1]), parseFloat(element), parseFloat(price[0]) <= parseFloat(element) && parseFloat(price[1]) >= parseFloat(element));
				// 		if (parseFloat(price[0]) <= parseFloat(element) && parseFloat(price[1]) >= parseFloat(element)) {
				// 			return true;
				// 		}
				// 		return false;
				// 	});
				// }
				//&& parseFloat(price[1]) >= parseFloat(this.$store.getters.getLargestPrice)
				if (parseFloat(higher) >= parseFloat(this.$store.getters.getLargestPrice)) {
					return true;
				}
				return false;
			},
			checkingServing(serving) {
				serving = serving.split('-');
				if (parseFloat(serving[1]) >= parseFloat(this.$store.getters.getLargestServing)) {
					//&& parseFloat(serving[1]) >= parseFloat(this.$store.getters.getLargestServing)
					return true;
				}
				return false;
			},
			doFiltration() {
				const data = {
					type: 'regular',
					text: this.getSearchText,
					cat: this.getSearchCat.catID,
					dish: this.getFilterDish,
					event: this.getFilterEvent,
					people: this.getFilterPeople,
					price: this.getFilterPrice,
					category: this.productsCategory
				};
				this.$store.dispatch('setSearchProducts', data);
			}
		},
		computed: {
			getSearchText() {
				return this.$store.getters.getSearchText;
			},
			getSearchCat() {
				return this.$store.getters.getSearchCat;
			},
			getFilterDish() {
				return this.$store.getters.getChosenFilterDishType;
			},
			getFilterEvent() {
				return this.$store.getters.getChosenFilterEventType;
			},
			getFilterPeople() {
				return this.$store.getters.getChosenFilterPeople;
			},
			getFilterPrice() {
				return this.$store.getters.getChosenFilterPrice;
			},
		},
		components: {
			SvgIcon
		},
		data() {
			return {
				show: false,
				// eslint-disable-next-line no-undef
				productsCategory: productsCategory,
				selectedTags: [],
				getPrices: [],
				getServings: [],
				getTypes: []
			};
		}
	};
</script>

<style lang="scss" scoped>
	.filter-item {
		position: relative;
		font-family: $font-second;
		font-size: 18px;
		width: 22%;
		max-width: 236px;
		border-bottom: 1px solid $happy-blue;
		@include mq($md) {
			// display: block;
			max-width: 100%;
			width: 48%;
			margin-bottom: 20px;
		}

		@include mq($sm) {
			width: 100%;
		}
	}

	.filter-item__name {
		padding: 15px 12px 12px 7px;
		display: flex;
		align-items: center;
		cursor: pointer;
		transition: color $dur $ease;

		&:hover {
			color: $burning-orange;

			.filter-item__icon {
				color: $burning-orange;
			}
		}
	}

	.filter-item__icon {
		color: $happy-blue;
		font-size: 16px;
		width: 16px;
		height: 16px;
		margin-left: auto;
		transition: color $dur $ease;
	}

	.filter-item__list {
		position: absolute;
		z-index: 1;
		top: calc(100% + 1px);
		left: 0;
		width: 100%;
		background-color: $white;

		&::before {
			content: '';
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
		}
	}

	.filter-item__item {
		position: relative;
		z-index: 1;
		display: flex;
		min-height: 40px;
		align-items: center;
		padding: 4px 14px 4px 7px;
		transition: $dur $ease;
		cursor: pointer;

		&:hover {
			background-color: $burning-orange;
			color: $white;
		}
	}

	.fade-enter-active, .fade-leave-active {
		transition: opacity $dur $ease;
	}

	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
</style>
